export default __webpack_public_path__ + "6b55aebe083bc7976b836c29f379d542.jpeg";